/**
 * Runs one asynchronous operation at a time and shares its result with all callers.
 * A failed operation can be retried; a completed operation remains completed.
 */
export class SingleFlight {
  private completed = false;
  private inFlight: Promise<void> | null = null;

  run(operation: () => Promise<void>): Promise<void> {
    if (this.completed) return Promise.resolve();
    if (this.inFlight) return this.inFlight;

    const current = operation()
      .then(() => {
        this.completed = true;
      })
      .finally(() => {
        if (this.inFlight === current) {
          this.inFlight = null;
        }
      });

    this.inFlight = current;
    return current;
  }

  reset(): void {
    this.completed = false;
    this.inFlight = null;
  }
}
